"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleBreadcrumb = void 0;
const chevron_1 = require("@geome/react-components-next/lib/components/icons/chevron");
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const react_1 = __importStar(require("react"));
const SingleBreadcrumb = ({ at = -2, breadcrumbs }) => {
    const link = breadcrumbs.at(at);
    if (!link)
        throw new Error(`No link at ${at} in ${breadcrumbs}`);
    const { translate } = (0, i18n_1.useI18n)();
    const text = (0, react_1.useMemo)(() => {
        if (link.text) {
            return link.text;
        }
        if (link.translationToken) {
            return translate(link.translationToken);
        }
    }, [link.text, link.translationToken, translate]);
    return (react_1.default.createElement("a", { className: "single-breadcrumb", href: link.link },
        react_1.default.createElement(chevron_1.ChevronIcon, { direction: "left" }),
        text));
};
exports.SingleBreadcrumb = SingleBreadcrumb;
